import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSublime({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M15.382.002c.34 0 .62.28.62.62v14.76a.622.622 0 0 1-.62.616H.622a.622.622 0 0 1-.62-.619V.622c0-.34.28-.62.62-.62h14.76zM12.514 2.44c.143-.576-.451-.265-.451-.265L3.69 4.833c-.042.013-.322.117-.232.641L3.44 7.942c-.001.04.01.32.562.436l3.34 1.076-3.526 1.076c-.048.005-.424.062-.376.813.05.799-.004 2.407-.004 2.407s.036.297.444.125l8.372-2.672c.048-.013.248-.074.08-.144.074.018.24.027.214-.242l.004-2.75c.008-.037.044-.296-.437-.47L8.721 6.535l3.403-1.064c.516-.092.412-.468.412-.468l-.022-2.562z"/>
        </svg>
    );
}

export default IconSublime;
